export const updateProductModal = ( newState ) => ( {
    type: 'UPDATE_PRODUCT_MODAL',
    newState,
} );

export const complexUpdateProductModal = ( newState ) => ( {
    type: 'COMPLEX_UPDATE_PRODUCT_MODAL',
    newState,
} );

export const closeProductModal = () => ( {
    type: 'CLOSE_PRODUCT_MODAL',
} );

export const copyProductToList = function( product ) {
    return ( dispatch ) => {
        var newProduct = { ...product };
        delete newProduct.userid;
        delete newProduct.desierid;
        delete newProduct.listid;
        delete newProduct.dateCreated;

        var newState = {
            showListOptions: true,
            product: {
                ...newProduct,
                imageArr: [ newProduct.image ],
            },
            type: 'copy',
            showModal: 'detailsModal',
        };

        dispatch( updateProductModal( newState ) );
    };
};
